export const documentTypes = [
  { value: 'dni', label: 'DNI' },
  { value: 'ruc', label: 'RUC' }
];
